import { SlideProps } from "@/components/form/MultiStepForm";
import { createContext, SetStateAction, useContext, useState } from "react";
import ChooseTrailer from "./slides/ChooseTrailer";
import FinalizeAndDispatch from "./slides/FinalizeAndDispatch";
import PlanLoadForTrailer from "./slides/PlanLoadForTrailer";

const StageAndDispatchContext = createContext<StageAndDispatchContextType>(
  null as never
);

export const StageAndDispatchContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [slideNumber, setSlideNumber] = useState<number>(0);
  const slides: SlideProps[] = [
    {
      title: "Choose trailer",
      component: <ChooseTrailer />,
    },
    {
      title: "Plan load for trailer",
      component: <PlanLoadForTrailer />,
    },
    {
      title: "Finalize & dispatch",
      component: <FinalizeAndDispatch />,
    },
  ];
  return (
    <StageAndDispatchContext.Provider
      value={{ slideNumber, setSlideNumber, slides }}
    >
      {children}
    </StageAndDispatchContext.Provider>
  );
};

type StageAndDispatchContextType = {
  slideNumber: number;
  setSlideNumber: React.Dispatch<SetStateAction<number>>;
  slides: SlideProps[];
};

export const useStageAndDispatchContext = () =>
  useContext(StageAndDispatchContext);
